// 导出相关接口

import { postBlobFile, get, deleteApi, imagePost, postJson } from "../axios";

// 设置/去掉常用报表
export const collectReport = (p) => postJson(`/analysisConfig/set`, p);

// 查询常用列表
export const getCollectList = (p) => get(`/analysisConfig/tree`, p);
